"use client"

import React, { useEffect } from "react";
const setCookie =  (
  name: string,
  value: string,
  expiresDays = 30,
  path = "/",
  domain = "",
  secure = false,
) => {
  let cookieString = `${name}=${encodeURIComponent(value)}`;

  if (expiresDays) {
    const date = new Date();
    date.setTime(date.getTime() + expiresDays * 24 * 60 * 60 * 1000); // 计算过期时间（以天数为单位）
    cookieString += `; expires=${date.toUTCString()}`;
  }

  cookieString += `; path=${path}`;

  if (domain) {
    cookieString += `; domain=${domain}`;
  }

  if (secure) {
    cookieString += "; Secure"; // 如果是https网站，可以添加Secure属性以使cookie只能通过安全连接传输
  }

  document.cookie = cookieString;
}

export default function SetCookieComponent(props: any) {
  useEffect(() => {
    setCookie("deviceId", props.deviceId, 30, "/", "", false);
  }, []);

  return <></>
}

